import React, { useState } from 'react';
import classNames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';
import { Card, CardHeader, CardBody } from 'shards-react';
import PageDropdown from './PageDropdown';
import { connect } from 'react-redux';
import ConfirmModal from '../../ConfirmModal';
import { removePageFromDoc, reorderThumbnails } from '../../../utils/redux/actions';
import { DRAG_AND_DROP_CONSTANTS } from 'utils/dndBoard/constants';

const Page = (props) => {
	const { id, url, pageNumber, columnId, setPageToDisplay, index, toggleSelection, toggleSelectionInGroup, multiSelectTo, isSelected, isGhosting, showDropdown, disableDrag, thumbnails, dispatch, saveHandler } = props;

	const borderColor = `border-${isSelected ? 'success' : 'transparent'}`;

	const classes = classNames('border-2', borderColor, 'mr-1', 'mb-1', isGhosting && 'ghost', 'dnd-page');

	const [confirmDeleteCard, setConfirmDeleteCard] = useState(false);

	const preventMiddleClick = (e) => (e.button === 1 ? (e.preventDefault(), e.target.focus()) : null);

	const onKeyDown = (e, snapshot) => {
		// already used
		if (e.defaultPrevented) return;
		if (snapshot.isDragging) return;
		if (e.keyCode !== 13) return;
		// we are using the event for selection
		e.preventDefault();

		performAction(e);
	};

	// Using onClick as it will be correctly
	// preventing if there was a drag
	const clickHandler = (e) => {
		if (e.defaultPrevented) return;
		if (e.button !== 0) return;
		// marking the event as used
		e.preventDefault();

		performAction(e);
	};

	// Determines if the platform specific toggle selection in group key was used
	const wasToggleInSelectionGroupKeyUsed = (e) => {
		const isUsingWindows = navigator.platform.indexOf('Win') >= 0;
		return isUsingWindows ? e.ctrlKey : e.metaKey;
	};

	// Determines if the multiSelect key was used
	const wasMultiSelectKeyUsed = (e) => e.shiftKey;

	const performAction = (e) => {
		if (wasToggleInSelectionGroupKeyUsed(e)) return toggleSelectionInGroup({ pageId: id, columnId });

		if (wasMultiSelectKeyUsed(e)) return multiSelectTo({ pageId: id, columnId });

		setPageToDisplay({ actual: pageNumber });

		toggleSelection({ pageId: id, columnId });
	};

	const previewPage = () => {
		return setPageToDisplay((oldState) => {
			if (oldState.actual === pageNumber) return oldState;

			return {
				...oldState,
				preview: pageNumber,
			};
		});
	};

	const leavePage = () =>
		setPageToDisplay((oldState) => {
			if ('preview' in oldState) return { actual: oldState.actual };
			return oldState;
		});

	const removePage = () => {
		const { [columnId]: columnToUpdate, ...restColumns } = thumbnails.columns;
		const { [id]: pageToRemove, ...restPages } = thumbnails.pages;

		const newOrder = {
			...thumbnails,
			columns: { ...restColumns },
			pages: { ...restPages },
		};

		if (columnId !== DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE && thumbnails.columns[columnId].pageIds.length <= 1) {
			newOrder.columnOrder = thumbnails.columnOrder.filter((id) => id !== columnId);
		} else {
			newOrder.columns[columnId] = { ...columnToUpdate, pageIds: columnToUpdate.pageIds.filter((pageId) => pageId !== id) };
		}

		return saveHandler({ newOrder, handleRemovedPage });
	};

	const handleRemovedPage = (response) => {
		if (!response) return closeModal();

		dispatch(reorderThumbnails(response));
		dispatch(removePageFromDoc(pageNumber));

		return;
	};

	const closeModal = () => setConfirmDeleteCard(false);

	return (
		<Draggable draggableId={id} index={index} isDragDisabled={disableDrag}>
			{(provided, snapshot) => (
				<div style={{cursor: disableDrag && 'pointer'}}>
					<Card innerRef={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={classes} onClick={clickHandler} onMouseDown={preventMiddleClick} onKeyDown={(e) => onKeyDown(e, snapshot)}>
						<CardHeader className='p-0 d-flex'>
							<span className='font-italic mx-auto'>{`Seite: ${pageNumber + 1}`}</span>
							{showDropdown && <PageDropdown columnId={columnId} pageId={id} setConfirmDeleteCard={setConfirmDeleteCard} />}
						</CardHeader>
						<CardBody className='p-0 text-center'>
							<img onMouseEnter={previewPage} onMouseLeave={leavePage} className='rounded w-100' alt={`thumbnail-${pageNumber}`} src={url} width='200' height='282' />
						</CardBody>
					</Card>
					{confirmDeleteCard && <ConfirmModal message={'Möchten Sie die Seite wirklich löschen?'} confirmFunction={removePage} closeModal={closeModal} />}
				</div>
			)}
		</Draggable>
	);
};

// Take thumbnails from redux state
const mapStateToProps = ({ savedDocument: { approved, thumbnails } }) => ({ showDropdown: !approved, thumbnails });

export default connect(mapStateToProps)(Page); //Connect the component with redux and export it.
